module.exports = __webpack_public_path__ + "static/media/Gradient_Client_Page_(optimized)3.c5a6135e.png";